<template>
  <div>
    <a-menu v-model:selectedKeys="selectedKeys" :open-keys="openKeys" theme="light" mode="inline">
      <a-menu-item key="dashboard">
        <router-link to="/">
          <DesktopOutlined />
          <span>工作台</span>
        </router-link>
      </a-menu-item>
      <a-sub-menu key="article_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>文章管理</template>
        <a-menu-item key="/articleCategory/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/articleCategory/index">文章分类</router-link>
        </a-menu-item>
        <a-menu-item key="/article/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/article/index">文章列表</router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="product_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>产品管理</template>
        <a-menu-item key="/productCategory/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/productCategory/index">产品分类</router-link>
        </a-menu-item>
        <a-menu-item key="/product/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/product/index">产品列表</router-link>
        </a-menu-item>

      </a-sub-menu>

      <a-sub-menu key="ad_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>轮播广告</template>
        <a-menu-item key="/adCategory/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/adCategory/index">轮播组管理</router-link>
        </a-menu-item>
        <a-menu-item key="/ad/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/ad/index">管理轮播</router-link>
        </a-menu-item>

      </a-sub-menu>


      <a-sub-menu key="project" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>项目管理</template>
        <a-menu-item key="/project/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/project/index">项目管理</router-link>
        </a-menu-item>
        <a-menu-item key="/project/category">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/project/category">项目分类</router-link>
        </a-menu-item>

      </a-sub-menu>

      <a-sub-menu key="tag_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>标签管理</template>
        <a-menu-item key="/tagCategory/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/tagCategory/index">标签分类管理</router-link>
        </a-menu-item>

      </a-sub-menu>


      <a-sub-menu key="nav" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>导航菜单</template>
        <a-menu-item key="/nav/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/nav/index">导航菜单</router-link>
        </a-menu-item>

      </a-sub-menu>



      <a-sub-menu key="user" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>用户管理</template>
        <a-menu-item key="/user/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/user/index">用户列表</router-link>
        </a-menu-item>
      </a-sub-menu>



      <a-sub-menu key="system" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>系统管理</template>
        <a-menu-item key="/site/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/site/index">站点设置</router-link>
        </a-menu-item>
        <a-menu-item key="/admin/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/admin/index">管理员列表</router-link>
        </a-menu-item>

        <a-menu-item key="/system/index">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/system/index">系统设置列表</router-link>
        </a-menu-item>

      </a-sub-menu>





    </a-menu>
  </div>
</template>

<script setup>
import {
  DesktopOutlined,
  ProjectOutlined, ProfileOutlined, SolutionOutlined,RetweetOutlined,AuditOutlined,
  DatabaseOutlined,
  ContainerOutlined,FileOutlined,SettingOutlined,
  TeamOutlined,UserSwitchOutlined,
  FileMarkdownOutlined,ControlOutlined,
  RollbackOutlined,
} from '@ant-design/icons-vue';
import {reactive, ref} from "vue";
import {getQueryString} from "@/utils/common";
const selectedKeys = ref([])
const openKeys = reactive(['workorder'])
//
const pathname = window.location.pathname
selectedKeys.value = [pathname]
console.log('window.location',pathname)
//查询上一级的key信息
const dataList = [
  {key:'article_category',path:'/articleCategory/index'},
  {key:'article_category',path:'/article/index'},
  {key:'product_category',path:'/productCategory/index'},
  {key:'product_category',path:'/product/index'},
  {key:'ad_category',path:'/adCategory/index'},
  {key:'ad_category',path:'/ad/index'},
  {key:'nav',path:'/nav/index'},
  {key:'user',path:'/user/index'},
  {key:'system',path:'/system/index'},
  {key:'system',path:'/site/index'},
  {key:'system',path:'/admin/index'},
  {key:'project',path:'/project/index'},
  {key:'project',path:'/project/category'},
  {key:'tag_category',path:'/tagCategory/index'},
]
const fIndex = dataList.findIndex(t=>t.path === pathname)
console.log('fIndex',fIndex)
if(fIndex >= 0){
  const fKey = dataList[fIndex]['key']
  let newKey = fKey
  if(fKey === '/store/task/index'){
    let typeParam = getQueryString('category_no')
    newKey = fKey+'?category_no='+typeParam
    console.log('newKey',newKey)
    Object.assign(openKeys, ['workorder',fKey,newKey]);
  }else {
    Object.assign(openKeys, ['workorder',newKey]);
  }
  console.log('fKey',fKey)

}
const titleClick = (e) => {
  console.log('titleClick',e)
}
</script>

<style scoped>

</style>